<i18n>
{
	"en": {
		"economicalStatus": "Economical status",
		"incomplete": "Incomplete",
		"notSettled": "Not settled",
		"settled": "Settled",
		"invoiced": "Invoiced",
		"recorded": "Recorded",
		"cancelled": "Cancelled"
	},
	"no": {
		"economicalStatus": "Økonomisk status",
		"incomplete": "Ufullstendig",
		"notSettled": "Ikke klarert",
		"settled": "Klarert",
		"invoiced": "Oppgjort",
		"recorded": "Bokført",
		"cancelled": "Annullert"
	}
}
</i18n>

<template>
	<t-form-group :title="$t('economicalStatus')" rowGap="5px">
		<slot name="before" />
		<t-select
			:selectedItem="selectedItem"
			:selectedItems="selectedItems"
			:items="economicalStatuses"
			:disabled="disabled"
			showPopoverOnFocus
			:enableFocusNextOnKeyboardSelect="enableFocusNextOnKeyboardSelect"

			@change="onChange"
			@select="$emit('select', $event)"
		>
			<template #displayedValue>
				<div class="list-item">
					<t-status-color-dot :color="getStatusColor(selectedItem)" />
					<div>
						{{ $t(getEconomicalStatus(selectedItem)) }}
					</div>
				</div>
			</template>
			<template #optionItemValue="{ item }">
				<div class="list-item">
					<t-status-color-dot :color="getStatusColor(item)" />
					<div>
						{{ $t(getEconomicalStatus(item)) }}
					</div>
				</div>
			</template>
			<!-- This will enables slots to be overwritten if the slot is defined further out -->
			<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
				<slot :name="slot" v-bind="scope"/>
			</template>
		</t-select>
		<slot name="after" />
	</t-form-group>
</template>

<script>
import { statuses } from '@/core';
import TSelect from '@/components/evergreen/inputs/TSelect';


export default {
	name: 'EconomicalStatusesFormInput',
	components: { TSelect },
	props: {
		selectedItem: Number,
		selectedItems: {
			type: Array,
			default: () => []
		},
		disabled: {
			type: Boolean,
			default: false
		},
		enableFocusNextOnKeyboardSelect: Boolean,
	},
	computed: {
		economicalStatuses() {
			return Object.values(statuses.economical);
		},
	},
	methods: {
		getEconomicalStatus(value) {
			return statuses.economical(value);
		},
		getStatusColor(value) {
			return statuses.economicalStatusColor(value);
		},
		onChange(value) {
			this.$emit('change', value);
		}
	}
};
</script>

<style lang="scss" scoped>
.list-item {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	> * {
		margin-right: 5px;
	}
}
</style>
